<!--
 * @name: 选择设备
 * @description: 选择设备
 * @author: huizi(huizi.li@shengyc.com)
 * @Date: 2020-04-20 13:51:39
 * @LastEditTime: 2021-08-31 11:22:25
 -->
<template>
    <div id="WarmSearchScreen"> 
        <nav-header
            bg="#0152b4"
            color="#ffffff"
            :key_word="q_name"
            :showInput="true"
            @clickSearch="$_clickSearch"
            inputHeadTitle="报警设置"
            placeholderText="请输入设备名称、编号、姓名"
        >
            <a href="javascript:;" class="nav-btn_left" slot="head_left" @click="$_goBack()" />
        </nav-header>  
        <div class="emptyList" v-show="warming_list.length == 0" v-if="!showLoading">
            <span>暂无数据</span>
        </div> 
        <van-list
            class="list-content"
            v-show="warming_list.length != 0"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            loading-text="加载中..."
            @load="$_onLoad"
        >
            <div
                v-for="(item, index) in warming_list"
                :key="'equipment' + index"
                class="warm-card"
                @click="$_clickItem(item)"
            >
                <div class="card">
                    <div class="card-fields" v-for="(field, fdx) in showFields" :key="fdx">
                        <span class="field_label">
                            {{field.label}}：
                        </span>
                        <span class="field_content">
                            {{computedFields(item, field.prop)}}
                        </span> 
                    </div>
                    <div class="card-open">
                        <div class="card-open-left">
                            是否开启
                        </div>
                        <div class="card-open-right">
                            <van-switch 
                                @change="openItem(item)" 
                                @click.stop=""
                                v-model="item.checked" 
                                active-color="#2AC958" 
                                inactive-color="#CCCCCC"  
                            />
                        </div>
                    </div>
                    <div class="card-bottom">
                        <div class="card-btn" @click.stop="delWarm(item)">删除</div>
                        <div class="card-btn" @click.stop="editWarm(item)">编辑</div>
                    </div>
                </div>
            </div>
        </van-list> 
        <div class="bottom-btn"> 
            <van-button class="submit-btn" @click="goToNewWarm()">
                <span>新增报警</span>
            </van-button>
        </div> 
    </div>
</template>

<script>
// @ is an alias to /src
import { 
    pathOr,
    strLimit,
    toDate, 
    toTimestamp,
} from '@/config/Utils'
import { Toast, Loading } from 'vant'
import { getWarningSettings, deleteWarningSettings, addWarningSetting, warningSettingsStatus } from '@/service/getData' 
// import pdf from 'vue-pdf';
// import Loading from '@/components/common/Loading/';
import NavHeader from '@/components/NavHeader/NavHeader.vue'
export default {
    name: 'Down',
    components: {
        NavHeader,
        // Loading,
    },
    data() {
        return {
            strLimit: strLimit,
            pathOr: pathOr,
            toDate: toDate,
            key_word: '',
            showLoading: true,
            warming_list: [],
            loading: false,
            finished: false,
            pageNum: 1,
            q_name: '', 
            user_origin: this.$store.state.account_origin || this.$store.state.user_origin,  
            showFields: [
                {label: '报警设备', prop: 'equipmentInfo'},
                {label: '报警级别', prop: 'warningLevel'},
                {label: '系统人员推送', prop: 'pushSystemStaff'},
                {label: '系统人员推送方式', prop: 'systemStaffPushType'},
                {label: '其他人员推送', prop: 'pushOtherStatff'},   
            ],
            warningLevelOption: {
                1: '高',
                2: '中',
                3: '低'
            },
            pushTypeOption: {
                0: '短信',
                1: '邮件', 
            },
        }
    },
    created() {
        // 清空缓存
        this.$store.commit('SET_WARMING_INFO', {})
        this.$_getData()
    },

    mounted() {},
    watch: {},
    methods: {  
        // 启用、停用
        openItem (item) { 
            let obj = {}
            obj.pushStatus = item.checked ? 0 : 1 
            obj.id = item.id
            warningSettingsStatus(obj)
                .then(res => { 
                    Toast.clear()
                    Toast('切换成功!') 
                    this.$_getData()
                })
                .catch(err => {
                    // Toast.clear()
                })
        },
        // 编辑报警
        editWarm (item) {
            // 清空缓存
            this.$store.commit('SET_WARMING_INFO', {})
             this.$router.push({
                path: '/addWarm',
                query: { 
                    id: item.id,
                    from: '/warmSearchScreen'
                }
            })
        },
        // 删除报警
        delWarm (item) {
            this.loading = true
            deleteWarningSettings({id: item.id}).then(res => {
                Toast.clear()
                Toast('删除成功!') 
                this.loading = false
                this.$_getData() 
            }).catch(err => {
                this.loading = false
            })
        },
        // 获取指定name的 
        getKeyArrByArr(arr, key = 'name', key2) {
            let keyArr = []
            arr && arr.forEach(item => {
                if (item[key]) {
                    keyArr.push(`${item[key]} ${key2 ? `(${item[key2]})` : ''}`)
                }
            })
            return keyArr
        },
        // 对应显示内容
        computedFields (item, prop) {
            let value
            switch(prop) {
                case 'equipmentInfo':
                    value = this.getKeyArrByArr(item[prop], 'name', 'code').join(';')
                    break
                case 'pushSystemStaff':
                    value = this.getKeyArrByArr(item[prop], 'name').join(';')
                    break
                case 'pushOtherStatff': {  
                    let pushOtherStatffArr = [...(item.otherStaffPhone || []), ...(item.otherStaffEmail || [])]
                    value = pushOtherStatffArr.join(';')
                    break
                }
                case 'systemStaffPushType': {
                    let arr = [] 
                    item[prop] && item[prop].forEach(atm => {
                        arr.push(this.pushTypeOption[atm])
                    }) 
                    value = arr.join(';')
                    break
                }
                case 'warningLevel': {
                    let arr = [] 
                    item[prop] && item[prop].forEach(atm => {
                        arr.push(this.warningLevelOption[atm])
                    }) 
                    value = arr.join(';')
                    break
                }
            }
            return value || '--'
        },
        // 新增报警
        goToNewWarm() {
            // 清空缓存
            this.$store.commit('SET_WARMING_INFO', {})
            this.$router.push({
                path: '/addWarm'
            })
        },
        //选中
        $_clickItem(item) {
            this.$router.push({
                path: '/warmDetail',
                query: { id: item.id },
            })
        },
        //搜索
        $_clickSearch(val) {
            this.q_name = val
            this.$_getData()
        },
        $_goBack() {
            this.$router.push('/main')
        },   
        $_getData() { 
            this.loading = true
           //盛云宝
            getWarningSettings({ 
                pageNum: this.pageNum,
                pageSize: 10,
                qName: this.q_name || '',  
            }).then((res) => {
                res.result && res.result.forEach(item => {
                    item.checked = item.pushStatus === 0 ? true : false
                })
                this.showLoading = false
                this.loading = false
                if (this.pageNum > 1 && pathOr([], ['result'], res).length > 0) {
                    this.warming_list = this.warming_list.concat(pathOr([], ['result'], res))
                } else {
                    this.warming_list = pathOr([], ['result'], res)
                }
                if (this.warming_list.length >= res.total) {
                    this.$_noMoreData()
                } 
            })
        },
        $_onLoad() {
            setTimeout(() => {
                this.pageNum += 1
                this.$_getData()
            }, 1000)
        },
        /**
         * 没有更多数据
         */
        $_noMoreData() {
            this.finished = true
        },
    },
}
</script>

<style lang="scss">
@import '../../assets/style/mixin.scss';
#WarmSearchScreen {
    @include wh(100vw, 100vh); 
    display: flex; 
    flex-direction: column; 
    padding-bottom: vw(64);
    .bottom-btn {
        position: fixed;
        z-index: 10;
        bottom: 0;
        @include fja(center, center);
        width: 100%;
        background: #ffffff;
        padding: vw(10) vw(16);
        .submit-btn {
            height: vw(44);
            width: 100%;
            background: #3766e1;
            font-size: vw(16);
            color: #ffffff;
            border-radius: vw(4);
            &:first-child {
                margin-right: vw(10);
            }
        }
    }
    .nav-btn_left {
        @include wh(vw(44), vw(44));
        display: block;
        background: transparent url('../../assets/images/left_arrow_W.png') no-repeat center center;
        background-size: vw(10), vw(18);
    }
    .emptyList {
        width: 100%;
        height: 70%;
        @include fja(center, center);

        span {
            @include sc(vw(14), #bbbbbb);
        }
    }
    .van-dropdown-menu {
        height: vw(30);
        // margin-bottom: vw(8);
    }
    .van-ellipsis {
        font-size: vw(14);
    }
    .list-content {
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        flex: 1; 
    }
    .warm-card {
        margin-top: vw(10);
    }
    .card {
        background-color: #fff;
        display: flex;
        flex-direction: column; 
        // margin-bottom: vw(8);
        margin: 0 vw(12) vw(8) vw(12);
        border-radius: vw(2);
        padding: vw(15); 
        .card-fields{
            margin-bottom: vw(10); 
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden; 
            letter-spacing: 1px;
            line-height: vw(20); 
            word-break: break-all;
            .field_label{
                font-size: vw(14);
                color: #999999; 
            }
            .field_content{
                font-size: vw(14);
                color: #333333; 
            }
        } 
        .card-open{
            display: flex;
            align-items: center;
            margin-bottom: vw(11);
            .card-open-left{
                flex: 1;
                font-size: vw(14);
                color: #333333;
            }
            .card-open-right{ 
                .van-switch{
                    font-size: vw(18);
                    border-color: white;
                    height: vw(22); 
                    width: vw(40);  
                }
                .van-switch__node {
                    top: vw(2);
                    left: vw(2);
                }
            }
        }
        .card-bottom{ 
            padding-top: vw(14);
            border-top: 1px solid #EEEEEE;
            display: flex;
            .card-btn{
                flex: 1;
                text-align: center; 
                color: #3D7BED;
            }
            .card-btn:first-child{
                border-right: 1px solid #EEEEEE;
            }
        }
    }
    .line {
        height: vw(1);
        width: 100%;
        background-color: #eee;
        margin-top: vw(8);
    }
    .van-popup {
        position: relative;
    } 
}
</style>
